import { ChangeDetectionStrategy, Component, Input, inject, input } from '@angular/core';

import type { User } from '@core/account-types';
import { AdminsAvatarsComponent } from '@core/account-ui';
import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import type { ResultRating } from '@core/interview-results-types';
import { InterviewEvaluationRatingComponent } from '@core/interview-results-ui';
import type { Guest } from '@core/notes-types';
import { DividerComponent, GroupComponent, RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-overall-item-row',
  templateUrl: 'overall-item-row.component.html',
  styleUrls: ['./overall-item-row.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    InterviewEvaluationRatingComponent,
    RtTooltip,
    GroupComponent,
    AdminsAvatarsComponent,
    DividerComponent,
    TranslatePipe,
  ],
})
export class OverallItemRowComponent {
  private readonly i18n = inject(I18nService);

  public readonly totalRatingsCount = input<number>(undefined!);
  @Input() public rating: ResultRating;
  // Please keep it as arrow, it's important to keep `this` if we're passing this function outside
  public renderAdminTooltip = (adminOrGuest: User | Guest) => {
    if (!adminOrGuest.id || (<User>adminOrGuest).anonymizedAt) {
      return this.i18n.translate('app.common.deleted_user');
    }
    if ((<Guest>adminOrGuest).authToken) {
      return (<Guest>adminOrGuest).name;
    } else {
      return (<User>adminOrGuest).firstName + ' ' + (<User>adminOrGuest).lastName;
    }
  };

  public get percentRating(): string {
    const percentValue = Math.round(this.calculateWidth());
    return `${percentValue}%`;
  }

  public isGray(): boolean {
    return ['no', 'strong_no', 'neutral', null].includes(this.rating.rating);
  }

  public calculateWidth(): number {
    return (this.rating.count / this.totalRatingsCount()) * 100;
  }

  public get adminsWithGuests() {
    return [...this.rating.admins, ...this.rating.guests];
  }
}
